export enum FileExtensionEnum {
    AB1 = '.ab1',
    SEQ = '.seq',
}
